import { render, staticRenderFns } from "./Coupons.vue?vue&type=template&id=b60dda8a&scoped=true&"
import script from "./Coupons.vue?vue&type=script&lang=js&"
export * from "./Coupons.vue?vue&type=script&lang=js&"
import style1 from "./Coupons.vue?vue&type=style&index=1&id=b60dda8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60dda8a",
  null
  
)

export default component.exports